export const MAX_UPLOAD_FILE_SIZE = 5242880; // 10 MB


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/constants/file.ts